import { Routes } from '@angular/router';
import { LayoutComponent } from './core/components/layout/layout.component';
import { authGuard } from './core/auth/auth.guard';
import { pageTranslationsResolver } from './core/utils/page-translations.resolver';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        resolve: { translations: pageTranslationsResolver('dashboard') },
      },
      {
        path: 'warehouse',
        loadComponent: () =>
          import('./pages/warehouse/warehouse.component').then(m => m.WarehouseComponent),
        resolve: { translations: pageTranslationsResolver('warehouse') },
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.component').then(m => m.ProfileComponent),
        resolve: { translations: pageTranslationsResolver('profile') },
      },
      {
        path: 'waste',
        loadComponent: () =>
          import('./pages/waste/waste.component').then(m => m.WasteComponent),
        resolve: { translations: pageTranslationsResolver('waste') },
      },
      {
        path: 'chemicals',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/chemicals/chemicals.component').then(m => m.ChemicalsComponent),
            resolve: { translations: pageTranslationsResolver('chemicals') },
          },
          {
            path: 'requests',
            loadComponent: () =>
              import('./pages/chemicals/transfer-requests/transfer-requests.component').then(
                m => m.TransferRequestsComponent,
              ),
            resolve: { translations: pageTranslationsResolver('chemicals') },
          },
          {
            path: 'contracts',
            loadComponent: () =>
              import('./pages/chemicals/contracts/contracts.component').then(
                m => m.ContractsComponent,
              ),
            resolve: { translations: pageTranslationsResolver('chemicals') },
          },
        ],
      },
      {
        path: 'documentation',
        loadComponent: () =>
          import('./pages/documentation/documentation.component').then(
            m => m.DocumentationComponent,
          ),
        resolve: { translations: pageTranslationsResolver('documentation') },
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/reports.component').then(m => m.ReportsComponent),
        resolve: { translations: pageTranslationsResolver('reports') },
      },
      {
        path: 'admin',
        children: [
          {
            path: 'org-structure',
            loadComponent: () =>
              import('./pages/admin/org-structure/org-structure.component').then(
                m => m.OrgStructureComponent,
              ),
            resolve: {
              translations: pageTranslationsResolver('admin/org-structure'),
              chemicalsTranslations: pageTranslationsResolver('chemicals'),
            },
          },
          {
            path: 'waste-codes',
            loadComponent: () =>
              import('./pages/admin/waste-codes/waste-codes.component').then(
                m => m.WasteCodesComponent,
              ),
            resolve: { translations: pageTranslationsResolver('admin/waste-codes') },
          },
          {
            path: 'users',
            children: [
              { path: '', redirectTo: 'collaborators', pathMatch: 'full' },
              {
                path: 'collaborators',
                loadComponent: () =>
                  import('./pages/admin/users/collaborators/collaborators.component').then(
                    m => m.CollaboratorsComponent,
                  ),
                resolve: { translations: pageTranslationsResolver('admin/users/collaborators') },
              },
              {
                path: 'internal',
                loadComponent: () =>
                  import('./pages/admin/users/internal-users/internal-users.component').then(
                    m => m.InternalUsersComponent,
                  ),
                resolve: { translations: pageTranslationsResolver('admin/users/internal') },
              },
            ],
          },
        ],
      },
    ],
  },
];
